import { render, staticRenderFns } from "./editUbicacion.vue?vue&type=template&id=62005e46"
import script from "./editUbicacion.vue?vue&type=script&lang=js"
export * from "./editUbicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports